import { useState } from 'react';

const VendorTrack = () => {

    const tracks = [
        {
            title: 'Listed Partner',
            description: 'Get your products and services in front of healthcare providers by listing them on CharmHealthHub.\n\nThis track is perfect for vendors such as business consultants, billers, and sales partners looking to gain visibility and reach a broader audience.\n\nYour professional solutions will be easily accessible to thousands of physicians and practices who trust CharmHealth for their practice management needs.'
        },
        {
            title: 'Practice Level Integrator',
            description: 'For vendors aiming to deliver a bespoke experience, our Practice-Level Integration track offers custom-built solutions tailored to specific user requirements.\n\nThis track ensures that your product seamlessly integrates with individual practices, providing a personalized and optimized experience for both physicians and their patients.\n\nThis is suitable for vendors who are getting started or offer a niche solution.'
        },
        {
            title: 'Fully Integrated Partner',
            description: 'Simplify the process and maximize your impact by becoming an integrated partner.\n\nThis option allows all CharmHealth users to implement your solution within their EHR without the need for extensive customization. This is a fast and efficient way to extend your reach and empower healthcare professionals with cutting-edge tools.\n\nThis tier is suitable for software vendors and service providers who offer complementary solutions to CharmHealth, making it easy for practices to sign up and access.'
        }
    ]

    const [expandedIndex, setExpandedIndex] = useState(0);

    const toggleExpand = (index) => {
        if (expandedIndex !== index) {
            setExpandedIndex(index);
        }
    };

    const [smallExpandedIndex, setSmallExpandedIndex] = useState(null);

    const toggleSmallExpand = (index) => {
        if (smallExpandedIndex !== index) {
            setSmallExpandedIndex(index);
        }
        else {
            setSmallExpandedIndex(null);
        }
    }

    return (
        <div className="w-full flex flex-col xl:px-[0px] pb-[40px] xl:pb-0">
            <div className="w-full flex flex-col xl:flex-row pb-[16px] xl:pb-[0px]">
                <div className="w-full 1.5xl:h-fit xl:w-1/2 xl:px-[40px] 1.5xl:pl-[104px] 1.5xl:pr-[100px] flex flex-col xl:py-[0] xl:pt-[64px] px-[20px] xs:px-[40px]">
                    <div className="mt-[40px] w-full flex flex-col items-center xl:items-start">
                        <h3 className="w-full 1.5xl:mt-[56px] text-usersTitle text-[36px] 1.5xl:text-[60px] text-left text-usersTitle font-allroundgothic font-[600] mb-0">Three Distinct Tracks</h3>
                        <p className="mt-[32px] 1.5xl:mt-[24px] 1.5xl:pr-[20px] text-[18px] text-[#505050] font-proximanova mb-0" style={{ lineHeight: '1.35' }}>Vendors are enrolled in one of the following tracks, each designed to cater to your unique business needs while also allowing users to easily find and contact you on our marketplace.</p>
                    </div>

                    <div className="mt-[32px] 1.5xl:mt-0  xl:pl-0 w-full grid grid-cols-1">
                        {tracks.map((track, index) => (
                            <div key={index} className={`mt-[20px] 1.5xl:mt-[48px] w-full flex flex-col pl-[32px] 1.5xl:pl-[64px] 1.5xl:py-4 ${expandedIndex === index ? 'border-l-[1px] 1.5xl:border-l-8 border-[#9A016A]' : 'border-l-4 1.5xl:border-l-8 border-transparent'}`}>
                                <div className="h-fit flex flex-row items-center justify-between" onClick={() => {
                                    toggleExpand(index);
                                    toggleSmallExpand(index);
                                }}>
                                    <h5 className={`1.5xl:text-[30px] font-proxima-nova font-semibold ${expandedIndex === index ? 'text-[#9A016A]' : 'text-[#505050]'} 
                                    ${smallExpandedIndex === index ? 'text-[#9A016A]' : 'text-[#505050]'} 
                                    hover:cursor-pointer mb-0 `} >{track.title}</h5>
                                    <div className="min-w-[17px] min-h-[12px] xl:hidden">
                                        {smallExpandedIndex === index ?
                                            (
                                                <svg width="17" height="12" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M8.43937 0.0370601C8.66467 0.0370601 8.8899 0.14081 9.06773 0.363099L16.1816 9.25526C16.5254 9.68503 16.5254 10.3964 16.1816 10.8262C15.8378 11.256 15.2686 11.256 14.9248 10.8262L8.43945 2.71953L1.9541 10.8262C1.61027 11.256 1.04116 11.256 0.69732 10.8262C0.353498 10.3964 0.353498 9.68505 0.69732 9.25526L7.81118 0.363099C7.98901 0.140815 8.2143 0.0370601 8.43953 0.0370601H8.43937Z" fill="#9A016A" />
                                                </svg>
                                            )
                                            :
                                            (
                                                <svg width="17" height="12" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M8.43953 11.1485C8.21424 11.1485 7.989 11.0448 7.81118 10.8225L0.697319 1.93035C0.353498 1.50057 0.353498 0.789175 0.697319 0.359381C1.04114 -0.070396 1.61026 -0.070396 1.9541 0.359381L8.43945 8.46608L14.9248 0.359381C15.2686 -0.070396 15.8378 -0.070396 16.1816 0.359381C16.5254 0.789159 16.5254 1.50056 16.1816 1.93035L9.06773 10.8225C8.8899 11.0448 8.6646 11.1485 8.43937 11.1485H8.43953Z" fill="#9A016A" />
                                                </svg>
                                            )}
                                    </div>
                                </div>
                                {smallExpandedIndex === index && (
                                    <p className="xl:hidden mt-[16px] h-fit text-[18px] text-[#505050] font-proximanova mb-0" style={{ lineHeight: '1.35' }} dangerouslySetInnerHTML={{ __html: tracks[smallExpandedIndex].description.replace(/\n/g, '<br/>') }} />
                                )}

                            </div>

                        ))}
                    </div>
                </div>
                <div className="hidden xl:block mt-[32px] xl:mt-0 1.5xl:h-screen w-full xl:w-1/2">
                    <div className="h-full bg-cover flex items-center justify-center p-[32px] md:p-[64px] 1.5xl:p-[96px]"
                        style={{ backgroundImage: `url(https://charmhealth-marketplace-assets.s3.amazonaws.com/Homepage/TrackBackground.png)` }}>

                        <div className="w-full h-fit bg-[#71004E] flex items-center p-[32px] md:p-[64px] 1.5xl:p-[80px] shadow-2xl">
                            <p className="h-fit text-[18px] text-white font-proximanova mb-0" style={{ lineHeight: '1.35' }} dangerouslySetInnerHTML={{ __html: tracks[expandedIndex].description.replace(/\n/g, '<br/>') }} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="mt-[32px] xl:mt-0 w-full flex flex-col xl:flex-row">
                <div className="1.5xl:mt-0 h-fit min-h-fit 1.5xl:h-screen 1.5xl:min-h-fit w-full xl:w-1/2">
                    <div className="h-[580px] xl:h-screen xl:min-h-[750px] bg-cover relative z-20"
                        style={{ backgroundImage: `url(https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/Homepage/TrackScreenshotsBackground.png)` }}>

                        <div className="absolute w-[320px] h-[380px] 1.5xl:w-[540px] 1.5xl:h-[520px] bg-cover z-30 top-[175px] right-[100px] 1.5xl:right-[72px] 1.5xl:top-[200px]"
                            style={{ backgroundImage: `url(https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/Homepage/TracksRearImage.png)` }}
                        ></div>
                        <div className={`absolute w-[320px] h-[350px] 1.5xl:w-[500px] 1.5xl:h-[580px] top-[75px] right-[20px]  1.5xl:-right-[140px] 1.5xl:top-[80px] bg-cover z-40 drop-shadow-2xl`}
                            style={{ backgroundImage: `url(https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/Homepage/TracksFrontImage.png)` }}
                        ></div>
                    </div>
                </div>

                <div className="mt-[40px] xl:mt-0 h-fit w-full xl:w-1/2 flex flex-col  md:p-[64px] 1.5xl:pl-[180px] 1.5xl:pr-[80px] px-[20px] xs:px-[40px]">
                    <h3 className="w-fit 1.5xl:mt-[44px] text-[36px] 1.5xl:text-[60px] text-left xl:text-left text-usersTitle font-allroundgothic font-[600] mb-0">
                        Your Listing.<br />Your Way.
                    </h3>
                    <p className="mt-[32px] 1.5xl:mt-[24px] h-fit text-[18px] font-proximanova text-[#505050] mb-0" style={{ lineHeight: '1.35' }}>CharmHealthHub allows you to fully manage your listing through your Vendor Portal.
                    </p>
                    <p className="xl:mt-[16px] h-fit text-[18px] font-proximanova text-[#505050] mb-0" style={{ lineHeight: '1.35' }}>
                        Through the portal, you can create a dedicated listing page with a unique URL that allows you to showcase your product at its best.
                    </p>

                    <p className="xl:mt-[16px] h-fit text-[18px] font-proximanova text-[#505050] mb-0" style={{ lineHeight: '1.35' }}>
                        Keep your listing page on brand with your logo; banner image; website and social media links, images, videos, product details, pricing info and more.
                    </p>
                    <p className="xl:mt-[16px] h-fit text-[18px] font-proximanova text-[#505050] mb-0" style={{ lineHeight: '1.35' }}>

                        Keep users informed about your latest developments by keeping your listing up-to-date.
                    </p>
                    <p className="xl:mt-[16px] h-fit text-[18px] font-proximanova text-[#505050] mb-0" style={{ lineHeight: '1.35' }}>

                        Engage with users directly through CharmHealthHub and get feedback through reviews.
                    </p>
                </div>
            </div>
        </div >
    );
}

export default VendorTrack;